

import React, {
    useState,
    useEffect,
    useRef,
    useMemo,
} from "react";

import api from "@helpers/api.js";

import Config from "@config";


import { useAuth } from "@contexts/AuthContext.js";

import * as Mui from "@mui/material";

import PersonIcon from "@mui/icons-material/Person";
import CloseIcon from "@mui/icons-material/Close";
import SendIcon from "@mui/icons-material/Send";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import DownloadIcon from "@mui/icons-material/Download";

import { ReactComponent as ExcelIcon } from "@assets/custom-icons/excel.svg";
import { ReactComponent as PDFIcon } from "@assets/custom-icons/pdf.svg";

import InfiniteScroll from "react-infinite-scroll-component";

import { Button, Input } from "@fragments";
import { AddRounded } from "@mui/icons-material";

import "./styles.scss";



export default function CurrentChat({ info, handleOpenPreview, onClose }) {
    const [loading, setLoading] = useState(true);
    const [messages, setMessages] = useState([]);

    const { user } = useAuth();

    const [file, setFile] = useState();

    const REF_messagesBox = useRef();
    const REF_socket = useRef();
    const REF_newMessageInput = useRef();

    console.log("Info", info);

    useEffect(() => {
        if (loading) handleLoadMessages();
    }, [loading]);

    useEffect(() => {
        setLoading(true);

        return () => {
            if (REF_socket.current) {
                REF_socket.current.close();
                REF_socket.current = null;
            }
        };
    }, [info]);

    async function getChatId() {
        try {
            const { data } = await api.get(
                "chat/history?userId=" + info.user_id
            );
            return data;
        } catch (e) {
            console.log("Error loading messages", e);
        }
    }

    async function handleLoadMessages(bypassReconnect = false) {
        REF_socket.current = null;

        try {
            const { data } = await api.get("chat/history?userId=" + info.user_id);
            console.log("Messages", data);
            if (!bypassReconnect) {
                handleConnectToChat();
                registerView();
            }
            setMessages([...data.messages.reverse()]);
            setTimeout(() => scrollToBottom(!bypassReconnect), 10);
        } catch (e) {
            console.log("Error loading messages", e);
        }

        setLoading(false);
    }
    async function registerView() {
        try {
            const { data } = await api.post("chat/message/registerView", {
                sender_id: info.user_id,
            });
        } catch (e) { }
    }

    function scrollToBottom(smooth = true) {
        /* console.log(REF_messagesBox.current?.scrollHeight);
        REF_messagesBox.current?.scrollTo({
          top: REF_messagesBox.current?.scrollHeight,
          behavior: smooth ? "smooth" : "instant",
        });*/
    }

    async function handleConnectToChat() {
        const endpoint = Config.wsEndpoint;
        const chatId = info.id ? info.id : await getChatId();
        const channel = "chat." + chatId;

        const ws = new WebSocket(endpoint);

        ws.onopen = () => {
            if (REF_socket.current) {
                REF_socket.current.close();
            }
            REF_socket.current = ws;
            console.log("Conectado a", channel);
            ws.send(
                JSON.stringify({
                    event: "pusher:subscribe",
                    data: {
                        channel: channel,
                    },
                })
            );
        };

        ws.onmessage = (e) => {
            const data = JSON.parse(e.data);
            if (data && data.event === "MessageSent") {
                if (data.channel !== channel) return;

                const messageInfo = JSON.parse(data.data).message;
                messageInfo.content = JSON.parse(messageInfo.content);
                messageInfo.created_at = new Date(messageInfo.created_at)
                    .toISOString()
                    .replace("T", " ")
                    .split(".")[0];

                if (messageInfo.sender_id === user.id) return;

                console.log("New message", data.channel, data);

                registerView();

                setMessages((prev) => [...prev, messageInfo]);
                setTimeout(() => scrollToBottom(false), 100);
            }
        };

        ws.onclose = () => {
            console.log("Conexão finalizada: ", channel);
            REF_socket.current = null;
        };

        ws.onerror = (e) => {
            console.log("Erro no websocket", e);
        };
    }

    const fileInputRef = useRef(null);

    const handleAddFile = () => {
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    };

    const handleFileChange = async (event) => {
        const file = event.target.files[0];
        if (file) {
            try {
                const maxSizeInBytes = 50 * 1024 * 1024; // 50 MB
                if (file.size > maxSizeInBytes) {
                    alert("O tamanho do arquivo excede 50 MB.");
                    return;
                }

                const fileType = getFileType(file.type);

                if (fileType === "UNSUPPORTED") {
                    alert("Arquivo não suportado");
                    return false;
                }

                const fileUpload = {
                    fileName: file.name,
                    type: fileType,
                };

                switch (fileType) {
                    case "IMAGE":
                        const res = await resizeImage(file, 720);
                        fileUpload.data = res.base64;
                        fileUpload.aspectRatio = res.aspectRatio || 1;
                        break;
                    case "PDF":
                    case "XLSX":
                        fileUpload.data = await convertFileToBase64(file);
                        break;
                    default:
                        console.log("Unsupported file type");
                }

                console.log(fileUpload);

                setFile({ ...fileUpload });
            } catch (e) {
                console.log("Error importing file", e);
            }
        }

        function getFileType(mimeType) {
            if (mimeType.startsWith("image/")) {
                return "IMAGE";
            } else if (mimeType === "application/pdf") {
                return "PDF";
            } else if (
                mimeType ===
                "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            ) {
                return "XLSX";
            } else {
                return "UNSUPPORTED";
            }
        }

        function resizeImage(file, maxWidth) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onload = (event) => {
                    const img = new Image();
                    img.onload = () => {
                        const aspectRatio = img.width / img.height;
                        const canvas = document.createElement("canvas");
                        const ctx = canvas.getContext("2d");
                        const scaleFactor = maxWidth / img.width;
                        canvas.width = maxWidth;
                        canvas.height = img.height * scaleFactor;
                        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
                        canvas.toBlob((blob) => {
                            const resizedFile = new File([blob], file.name, {
                                type: file.type,
                            });
                            convertFileToBase64(resizedFile)
                                .then((base64) => resolve({ base64, aspectRatio }))
                                .catch(reject);
                        }, file.type);
                    };
                    img.src = event.target.result;
                };
                reader.readAsDataURL(file);
            });
        }

        function convertFileToBase64(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onload = () => resolve(reader.result);
                reader.onerror = reject;
                reader.readAsDataURL(file);
            });
        }
    };

    function ChatHeader() {
        const getInitials = (name) => {
            if (!name) return "";
            const parts = name.trim().split(/\s+/);
            if (parts.length === 1) return parts[0].substring(0, 2).toUpperCase();
            return (parts[0][0] + (parts[parts.length - 1][0] || "")).toUpperCase();
        };

        return (
            <div className="px-2 chat-header">
                <div>
                    <Mui.Badge
                        color="success"
                        variant="dot"
                        overlap="circular"
                        badgeContent=" "
                        anchorOrigin={{
                            vertical: "bottom",
                            horizontal: "right",
                        }}
                        className="online-badge"
                    >
                        <div className="user-avatar" style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', overflow: 'hidden' }}>
                            {info.avatar ? (
                                <img src={info.avatar} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                            ) : (
                                <>
                                    {info.username ? (
                                        <span style={{ fontSize: '10px', fontWeight: '600', textTransform: 'uppercase' }}>
                                            {getInitials(info.username)}
                                        </span>
                                    ) : (
                                        <PersonIcon fontSize="small" />
                                    )}
                                </>
                            )}
                        </div>
                    </Mui.Badge>
                </div>
                <h5 className="bold">{info.username || info.email}</h5>
                <Mui.IconButton
                    size="small"
                    onClick={() => {
                        onClose();
                        if (REF_socket.current) {
                            REF_socket.current.close();
                            REF_socket.current = null;
                        }
                    }}
                >
                    <CloseIcon size="small" />
                </Mui.IconButton>
            </div>
        );
    }

    function MessagesBox() {
        function Loading() {
            return (
                <div className="mt-3 messages-loading-row">
                    <Mui.Skeleton
                        variant="rectangular"
                        width={180}
                        height={24}
                        className="mt-1 message-loading"
                    />
                    <Mui.Skeleton
                        variant="rectangular"
                        width={210}
                        height={24}
                        className="mt-1 message-loading"
                    />
                    <Mui.Skeleton
                        variant="rectangular"
                        width={80}
                        height={24}
                        className="mt-1 message-loading"
                    />
                </div>
            );
        }

        return (
            <div
                className="messages-box px-2 py-3"
                id="scrollableDiv"
                ref={REF_messagesBox}
                style={{
                    height: 300,
                    overflow: "auto",
                    display: "flex",
                    flexDirection: "column-reverse",
                }}
            >
                {!loading ? (
                    <InfiniteScroll
                        dataLength={messages.length}
                        inverse={true}
                        scrollableTarget="scrollableDiv"
                    >
                        {messages?.map((item, k) => (
                            <Message
                                data={item}
                                key={item.id}
                                info={info}
                                handleOpenPreview={handleOpenPreview}
                            />
                        ))}
                    </InfiniteScroll>
                ) : (
                    ["", "", "", "", "", "", "", "", ""].map((_, i) => (
                        <Loading key={i} />
                    ))
                )}
            </div>
        );
    }

    function Footer() {
        const [val, setVal] = useState('')
        const [loading, setLoading] = useState(false)

        async function handleSendMessage(e) {
            e?.preventDefault();

            if (!val?.trim() && !file?.data) return;

            try {
                setLoading(true)

                const payload = {
                    text: val?.trim() || '',
                    receiver_id: info.user_id,
                };

                if (!!file && !!file?.data) {
                    payload.asset = {
                        data: file.data,
                        type: file.type,
                        contentInfo: {
                            fileName: file.fileName,
                        },
                    };

                    payload.asset.data = payload.asset.data.split(",")[1];

                    if (file.type === "IMAGE") {
                        payload.asset.contentInfo.imageAspectRatio = file.aspectRatio;
                    }
                }

                const { data } = await api.post("chat/message", payload);

                setFile(null);

                if (data.success) {
                    handleLoadMessages(true);
                }
            } catch (e) {
                console.log(e);
            } finally {
                setLoading(false)
            }
        }

        return (
            <form className="chat-footer px-2 py-1" onSubmit={handleSendMessage}>
                <input
                    type="file"
                    ref={fileInputRef}
                    style={{ display: "none" }}
                    onChange={handleFileChange}
                />
                <Input.Text
                    start={
                        <Button
                            onClick={handleAddFile}
                            color="text"
                            size="small"
                            type="button"
                            icon={<AttachFileIcon fontSize="small" />}
                        />
                    }
                    end={
                        <Button
                            type="submit"
                            color="primary"
                            size="small"
                            className="my-1"
                            loading={loading}
                            icon={<SendIcon fontSize="small" />}
                        />
                    }
                    emoji
                    ref={REF_newMessageInput}
                    fullWidth
                    placeholder={
                        "Enviar mensagem para " +
                        (info.username?.split(" ")[0] || info.email)
                    }
                    id="fullWidth"
                    variant="large"
                    autoFocus
                    onInput={setVal}
                />
            </form>
        );
    }

    function FilePreview() {
        function ImagePreview() {
            return (
                <div className="file slide-bottom-fade photo">
                    <div className="file-icon-area">
                        <img
                            src={file.data}
                            style={{ aspectRatio: file.aspectRatio }}
                            className="file-icon"
                        />
                    </div>
                    <small className="file-title photo">{file.fileName}</small>
                </div>
            );
        }
        function XLSXPreview() {
            return (
                <div className="file slide-bottom-fade excel">
                    <div className="file-icon-area">
                        <ExcelIcon className="file-icon excel" />
                    </div>
                    <small className="file-title excel">{file.fileName}</small>
                </div>
            );
        }
        function PDFPreview() {
            return (
                <div className="file slide-bottom-fade pdf">
                    <div className="file-icon-area">
                        <PDFIcon className="file-icon pdf" />
                    </div>
                    <small className="file-title pdf">{file.fileName}</small>
                </div>
            );
        }
        return (
            <div className="file-preview px-2">
                {file.type === "IMAGE" && <ImagePreview />}
                {file.type === "XLSX" && <XLSXPreview />}
                {file.type === "PDF" && <PDFPreview />}
                <Mui.IconButton
                    type="button"
                    className="remove-attachment-btn mr-1"
                    onClick={() => setFile(null)}
                >
                    <CloseIcon color="white" />
                </Mui.IconButton>
            </div>
        );
    }

    return (
        <div className="chat">
            <ChatHeader />
            <Mui.Divider />
            <MessagesBox />
            {file && <FilePreview />}
            <Footer />
        </div>
    );
}


function Message({ data, info, handleOpenPreview }) {
    const received = data.sender_id === info.user_id;

    const onlyImageMsg = data.asset_url && !data.content.text;

    const AssetComponent = {
        IMAGE: () => (
            <img
                onClick={() => handleOpenPreview(data.asset_url)}
                src={data.asset_url}
                className="message-img"
            />
        ),
        XLSX: () => (
            <div style={{ width: "100%" }} className="file slide-bottom-fade excel">
                <div className="file-icon-area">
                    <ExcelIcon className="file-icon excel" />
                </div>
                <small className="file-title excel">{data.content.fileName}</small>
                <Mui.IconButton
                    className="file-download"
                    onClick={() =>
                        downloadFileFromUrl(data.asset_url, data.content.fileName)
                    }
                >
                    <DownloadIcon />
                </Mui.IconButton>
            </div>
        ),
        PDF: () => (
            <div style={{ width: "100%" }} className="file slide-bottom-fade pdf">
                <div className="file-icon-area">
                    <PDFIcon className="file-icon pdf" />
                </div>
                <small className="file-title pdf">{data.content.fileName}</small>
                <Mui.IconButton
                    className="file-download"
                    onClick={() =>
                        downloadFileFromUrl(data.asset_url, data.content.fileName)
                    }
                >
                    <DownloadIcon />
                </Mui.IconButton>
            </div>
        ),
    }[data.asset_type];

    return (
        <div className={"message-row " + (received && "received")}>
            <div
                className={
                    "chat-message " +
                    (received && " received ") +
                    (onlyImageMsg && " only-image ") +
                    (data.asset_type === "IMAGE" && " has-image ")
                }
            >
                {data?.asset_url && <AssetComponent />}
                <span className="msg-text">
                    {data?.content?.text
                        ?.split(/(https?:\/\/[^\s]+)/g)
                        .map((part, index) => {
                            if (/(https?:\/\/[^\s]+)/g.test(part)) {
                                return (
                                    <a
                                        key={index}
                                        href={part}
                                        target="_blank"
                                        className="message-link"
                                        rel="noopener noreferrer"
                                    >
                                        {part}
                                    </a>
                                );
                            }
                            return part;
                        })}
                </span>
                <span className="date-label">
                    {data?.created_at.split(" ")[1].slice(0, 5)}
                </span>
            </div>
        </div>
    );
}



async function downloadFileFromUrl(url, filename) {
    try {
        var link = document.createElement("a");
        link.download = filename;
        link.href = url;
        link.click();
        link.remove();
    } catch (error) {
        console.error("There was an error downloading the file:", error);
    }
}
